import {
    FieldId,
    ExtendedFieldId,
    Validator,
    ExtendedErrorId,
    setCustomValidator,
    FieldContent,
    FormValidationOptions,
} from '@sheerid/jslib';

export const regionValidator = () => {
    const region: ExtendedFieldId = 'region';

    const getRegionValidationError: Validator = (value: FieldContent, formOptions?: FormValidationOptions): ExtendedErrorId => {
        if (!formOptions) return undefined;

        const invalidError: ExtendedErrorId = 'invalidRegion';
        const fieldsToSkip: (FieldId|ExtendedFieldId)[] = Object.assign([], formOptions.viewModel?.fieldsToSkipValidation);

        if (fieldsToSkip.includes(region)) return undefined;

        return (!value) ? invalidError : undefined;
    };

    setCustomValidator(region, getRegionValidationError);
};
